import React from 'react';
import Heatmap from '../componentes/NuevoProcesoComp/Heatmap';

export const Graficos = () => {
    return (
    <div className='general'>
        <Heatmap/>
    </div>
    );
};